import { Link } from "react-router-dom";
import Container from "@/components/base/Container";
import Reveal from "@/components/feature/Reveal";
import { topics } from "@/mocks/melons";
import { topicIconTone } from "@/utils/tone";

const countMap: Record<string, string> = {
  "yule-shijian": "312",
  "yingshi-xuanfa": "256",
  "zongyi-muhou": "188",
  "daiyan-fengbo": "142",
  "yinyue-xianchang": "176",
  "wangluo-redian": "212",
};

export default function TopicGrid() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <Container>
        <Reveal className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-[0.22em] text-secondary-700">瓜田分类</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              从六个入口开始翻时间线
            </h2>
          </div>
          <Link
            to="/topics"
            className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-600"
          >
            全部分类与筛选
            <i className="ri-arrow-right-line"></i>
          </Link>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {topics.map((topic, index) => (
            <Reveal key={topic.slug} delay={index * 70}>
              <Link
                to={`/topics?topic=${topic.slug}`}
                className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300"
              >
                <div className="flex items-start justify-between">
                  <span
                    className={`flex h-11 w-11 items-center justify-center rounded-md text-lg ${topicIconTone[topic.tone]}`}
                  >
                    <i className={topic.icon}></i>
                  </span>
                  <span className="text-xs text-foreground-500">{countMap[topic.slug]} 篇</span>
                </div>
                <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
                  {topic.name}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{topic.description}</p>
                <span className="mt-5 flex items-center gap-1 text-xs font-medium text-primary-600">
                  浏览分类
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}